import { memo } from 'react'

import { IDivider } from './divider.type'
import css from './divider.module.scss'


/** Разделительная линия разделяет различный контент. */
export default memo (({variant, type, size, margin, prefix, suffix}: IDivider) => {
    const getVariant = () => {
        switch (variant) {
            case 'dark': return css.divider_line_dark
            case 'light': return css.divider_line_light
            default: return css.divider_line_dark
        }
    }

    const getType = () => {
        const marginHorizontalStyle: React.CSSProperties = {
            paddingLeft: margin || '0px',
            paddingRight: margin || '0px'
        }
        const marginVerticalStyle: React.CSSProperties = {
            paddingTop: margin || '0px',
            paddingBottom: margin || '0px'
        }

        const sizeHorizontalStyle: React.CSSProperties = {width: size || '100%'}
        const sizeVerticalStyle: React.CSSProperties = {height: size || '100%',}
    
        switch (type) {
            case 'horizontal': return { size: sizeHorizontalStyle, margin: marginHorizontalStyle }
            case 'vertical': return { size: sizeVerticalStyle, margin: marginVerticalStyle }
            default: return { size: sizeHorizontalStyle, margin: marginHorizontalStyle }
        }
    }



    return <div className={`${css.divider_container}`} style={getType().margin}>
        {prefix}
        <span className={`${getVariant()}`} style={getType().size}></span>
        {suffix}
    </div>
})